import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { NavLink } from "react-router-dom";

const Login=()=>{

  const handleSubmit=(e)=>{
    e.preventDefault()
  }

  return <>
          <Typography component="h1" variant="h5">
            Recuperar contraseña
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}> Recuperar contraseña </Button>
            <Grid container>
              <Grid item xs>
                <NavLink to="/" variant="body2">
                  <Typography>
                    Iniciar sesión
                  </Typography>
                </NavLink>
              </Grid>
            </Grid>
          </Box>
        </>
}

export default Login
